import { ReactNode } from 'react'

import { Badge, BadgeVariant } from '../Badge/index.js'
import { Icon } from '../Icon/index.js'
import { XIcon } from '../icons/index.js'

export type MultiselectInputBadgeProps = {
  children: ReactNode
  onRemove: () => void
  variant?: BadgeVariant
  className?: string
  disabled?: boolean
}

/** Dismissable badge which are used to display currently selected values in Multiselect */
export const MultiselectInputBadge = ({
  children,
  variant,
  className,
  disabled,
  onRemove,
  ...rest
}: MultiselectInputBadgeProps) => {
  return (
    <Badge
      variant={variant}
      className={className}
      truncate
      {...rest}
      trailingIcon={
        <button
          type="button"
          className="flex items-center justify-center rounded-base focus:outline-none focus-visible:ring ring-offset-0 transition duration-200"
          onClick={e => {
            e.stopPropagation()
            onRemove?.()
          }}
          disabled={disabled}
        >
          <span className="sr-only">Remove option</span>
          <Icon className="h-2 w-2">
            <XIcon />
          </Icon>
        </button>
      }
    >
      {children}
    </Badge>
  )
}
